import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chart: {
      width: 450,
      height: 200,
    },
    square: {
      width: 25,
      height: 15,
    },
    text: {
      width: 100,
      marginLeft: theme.spacing(1),
    },
  }),
);

export default useStyles;
